/**
 * Umožňuje pomocí atributu data-scroll-top-class definovat
 * třídu, která se má nastavit pokud není stránka na vrchu
 *
 * <div data-scroll-down-class="some-css-class"></div>
 */

const ATTR_NAME = 'data-scroll-down-class';

function processElement(element: HTMLElement)
{
    let switchClass = element.dataset.scrollDownClass as string;

    console.log(switchClass);
    if (window.scrollY === 0) {
        element.classList.remove(switchClass);
    } else {
        element.classList.add(switchClass);
    }
}

export function run()
{
    document.querySelectorAll<HTMLElement>('['+ATTR_NAME+']').forEach(function (element: HTMLElement) {
        processElement(element);
    });

    document.addEventListener('scroll', function () {
        document.querySelectorAll<HTMLElement>('['+ATTR_NAME+']').forEach(function (element: HTMLElement) {
            processElement(element);
        });
    });
}
